import * as LaunchDateOrder from 'show-page/constants/launch-date-order';
import * as VideoType from 'common/constants/video-type';
import { defaults, fromPairs, get, sortBy, uniq } from 'lodash';


export function getSeasonNames(seasons = [], videos = []) {
    const seasonNumbers = fromPairs(getSeasonNumbers(videos).map(num => {
        return [num, parseInt(num, 10) ? `Season ${num}` : 'Specials'];
    }));
    const seasonNames = seasons.reduce((acc, { name, number }) => {
        return Object.assign(acc, { [parseInt(number, 10) || 0]: name });
    }, {});
    return defaults(seasonNames, seasonNumbers);
}

export function getSeasonNumbers(videos = []) {
    return uniq(videos.map(v => parseInt(v.seasonNumber, 10) || 0));
}

export const sortByEpisodeNumber = () => {
    return (v) => {
        const episodeNumber = parseInt(v.episodeNumber, 10);
        if (v.type === VideoType.EPISODE) {
            return isNaN(episodeNumber) ? Number.POSITIVE_INFINITY : episodeNumber;
        } else {
            return isNaN(episodeNumber) ? Number.POSITIVE_INFINITY : -episodeNumber;
        }
    };
};

export const sortByClipNumber = () => {
    return (v) => {
        return get(v, 'episode.order', Number.POSITIVE_INFINITY);
    };
};

export const sortByLaunchDateOrder = (launchDateOrder = LaunchDateOrder.ASC) => {
    return (v) => {
        const launchDate = parseInt(v.launchDate, 10);
        if (!launchDate) return Number.POSITIVE_INFINITY;
        return (launchDateOrder === LaunchDateOrder.DESC || v.type === VideoType.CLIP) ? (launchDate * -1) : launchDate;
    };
};

export const sortBySeasonNumber = (seasonNumbers = []) => {
    return (v) => {
        const seasonNumber = parseInt(v.seasonNumber, 10);
        const seasonIndex = seasonNumbers.indexOf(seasonNumber);
        if (isNaN(seasonIndex)) return Number.POSITIVE_INFINITY;
        return seasonIndex;
    }
};

export const sortVideos = (videos, { sortedSeasonNumbers, launchDateOrder }) => {
    return sortBy(videos, [
        sortBySeasonNumber(sortedSeasonNumbers),
        sortByEpisodeNumber(),
        sortByClipNumber(),
        sortByLaunchDateOrder(launchDateOrder)
    ]);
};



/** WEBPACK FOOTER **
 ** ./src/common/utils/video-utils.js
 **/